export default "__VITE_ASSET___dJOOLVF__"